import { render, staticRenderFns } from "./ModalEditSeriado.vue?vue&type=template&id=74d5b9ca&v-slot=activator&"
import script from "./ModalEditSeriado.vue?vue&type=script&lang=ts&"
export * from "./ModalEditSeriado.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditSeriado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports